import React, { Component, Fragment } from 'react';
import { Droppable } from 'react-beautiful-dnd';

import classNames from 'classnames';
import { I18n } from 'components/translate';
import { observer } from 'mobx-react';
import { ComponentNames, DatahubEventsService } from 'modules/app/services';
import ClickDeleteContentSchema from 'modules/app/services/datahubEvents/module/clickDeleteContentSchema';
import { ContentService, SeasonService } from 'modules/content';
import { ITEM_TYPE } from 'modules/content/constants';
import MembershipService from 'modules/membership/MembershipService';
import { UiService } from 'modules/ui';
import PropTypes from 'prop-types';
import QueryString from 'query-string';

import DraggingCard from './DraggingCard';
import ModuleType from './ModuleType';
import PageType from './PageType';

import OnboardingService from '../../onboarding/OnboardingService';
import ContentDeleteModal from '../ContentDeleteModal';

@observer
export default class DroppableContent extends Component {
  static propTypes = {
    items: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    checkedContent: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    type: PropTypes.string,
    isExtra: PropTypes.bool,
    isMobile: PropTypes.bool,
    checkAll: PropTypes.bool,
    closedDroppable: PropTypes.bool,
    checkAllpages: PropTypes.func,
    isModuleDragging: PropTypes.bool,
    isPageDragging: PropTypes.bool,
    expandModules: PropTypes.bool,
    id: PropTypes.string,
    className: PropTypes.string,
    onMouseDown: PropTypes.func,
    onMouseUp: PropTypes.func,
    openDuplicationModal: PropTypes.func,
    checkboxChange: PropTypes.func,
    clearCheckeds: PropTypes.func,
    onReceiveDuplicationStatus: PropTypes.func,
    showModalMass: PropTypes.func,
    updateCheckedModule: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      items: this.props.items,
      isModuleDragging: this.props.isModuleDragging,
      isPageDragging: this.props.isPageDragging,
      expandModules: this.props.expandModules,
      checkedContent: this.props.checkedContent,
      classesList: [],
      objItemIdClasses: {},
      isClassesLoaded: false,
      showModalUnitModule: false,
      showModalUnitPage: '',
      moduleName: [],
      openModulesList: []
    };

    this.cloneRef = React.createRef();
  }

  componentDidMount() {
    window.addEventListener('error', this.virtualizedEventsHandler);
  }

  componentWillUnmount() {
    window.removeEventListener('error', this.virtualizedEventsHandler);
  }

  virtualizedEventsHandler = (e) => {
    if (
      e.message.includes(
        'ResizeObserver loop completed with undelivered notifications.'
      ) ||
      e.message.includes('ResizeObserver loop limit exceeded')
    ) {
      e.stopImmediatePropagation();
    }
  };

  closeModalUnitModule = () => {
    this.setState({ showModalUnitModule: false });
  };

  showModalUnitModule = (id) => {
    this.setState({ showModalUnitModule: id });
  };

  closeModalUnitPage = () => {
    this.setState({ showModalUnitPage: '' });
  };

  showModalUnitPage = (id) => {
    this.setState({ showModalUnitPage: id });
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    const newState = {};

    if (prevState === null) {
      return null;
    }

    if (JSON.stringify(nextProps.items) !== JSON.stringify(prevState.items)) {
      Object.assign(newState, { items: nextProps.items });
    }
    if (
      JSON.stringify(nextProps.isModuleDragging) !==
      JSON.stringify(prevState.isModuleDragging)
    ) {
      Object.assign(newState, { isModuleDragging: nextProps.isModuleDragging });
    }
    if (
      JSON.stringify(nextProps.isPageDragging) !==
      JSON.stringify(prevState.isPageDragging)
    ) {
      Object.assign(newState, { isPageDragging: nextProps.isPageDragging });
    }
    if (
      JSON.stringify(nextProps.expandModules) !==
      JSON.stringify(prevState.expandModules)
    ) {
      Object.assign(newState, { expandModules: nextProps.expandModules });
    }
    if (
      JSON.stringify(nextProps.checkedContent) !==
      JSON.stringify(prevState.checkedContent)
    ) {
      Object.assign(newState, {
        checkedContent: nextProps.checkedContent,
        items: nextProps.items
      });
    }

    return newState;
  }

  getClassTooltipContent = async (itemId) => {
    const { isExtra } = this.props;
    const classesList = await ContentService.getModuleClassesInfo(
      itemId,
      isExtra
    );

    this.setState({ classesList, isClassesLoaded: true });
  };

  clearClassTooltipContent = () => {
    this.setState({ classesList: [], isClassesLoaded: false });
  };

  updateModuleName(name, index) {
    const { moduleName, items } = this.state;

    moduleName[index] = name;

    if (items[index] && !items[index].oldName) {
      items[index].oldName = items[index].name;
    }

    items[index].name = name;

    this.setState({ moduleName });
  }

  onBlurPageNameHandler = ({ target }) => {
    const { items } = this.state;

    const pageId = target.getAttribute('data-page');
    const newName = target.value.trim();
    const pageIndex = items.findIndex((element) => element.id === pageId);

    if (pageIndex > -1) {
      if (newName !== items[pageIndex].name) {
        ContentService.updatePageName(pageId, newName)
          .then(() => {
            UiService.setAlertSuccess('done');
          })
          .catch(() => {
            UiService.setAlertError('unexpected_error');
          });
      }

      target.value = newName;
    }
  };

  onBlurModuleNameHandler = (e) => {
    const { items } = this.state;

    const target = e.target;
    const moduleId = target.getAttribute('data-module');
    const newName = target.value.trim();
    const moduleIndex = items.findIndex((element) => element.id === moduleId);

    if (moduleIndex > -1) {
      const isNameChange =
        items[moduleIndex].oldName && newName !== items[moduleIndex].oldName;

      if (isNameChange) {
        ContentService.updateModuleName(moduleId, newName)
          .then(() => {
            UiService.setAlertSuccess('done');
          })
          .catch(() => {
            UiService.setAlertError('unexpected_error');
          });
      }

      items[moduleIndex].oldName = newName;
      this.updateModuleName(newName, moduleIndex);
    }
  };

  isPageChecked(id, parentId) {
    const { checkedContent } = this.state;
    const pagesCheckeds = checkedContent && checkedContent.pages;

    const isModuleChecked = checkedContent.modules.includes(parentId);
    const isPageChecked =
      pagesCheckeds && pagesCheckeds.length && pagesCheckeds.includes(id);

    return isModuleChecked || isPageChecked;
  }

  pageHandleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.onBlurPageNameHandler(e);
      this.removeBorderAndBlur(e);
    }
  };

  moduleHandleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.onBlurModuleNameHandler(e);
      this.removeBorderAndBlur(e);
    }
  };

  removeBorderAndBlur(e) {
    e.target.blur();
    e.target.classList.add('transparent-border');

    setTimeout(
      (target) => {
        if (target) {
          target.classList.remove('transparent-border');
        }
      },
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      2000,
      e.target
    );
  }

  get actionsToggle() {
    return ' ';
  }

  addParam(url, paramName, paramValue) {
    const params = QueryString.parseUrl(url);

    params.query[paramName] = paramValue;

    return `${params.url}?${QueryString.stringify(params.query)}`;
  }

  urlWithParams(url, params) {
    let newUrl = url;

    for (const param in params) {
      if (params[param]) {
        newUrl = this.addParam(newUrl, param, params[param]);
      }
    }

    return newUrl;
  }

  renderModuleFlags(item) {
    return (
      <Fragment>
        {item.publicModule && (
          <p className="module-public-flag -first">
            <I18n label="content_list.not_paid" />
          </p>
        )}
        {item.paidModule && (
          <p className="module-public-flag -first">
            <I18n label="content_list.paid" />
          </p>
        )}
        <p
          className={classNames('module-pages-flag', {
            '-first': !item.publicModule && !item.paidModule
          })}
        >
          {item.totalPages ? (
            <I18n
              label="content_list.total_pages"
              data={{ amount: item.totalPages, count: item.totalPages }}
            />
          ) : (
            <I18n label="content_list.total_pages_none" />
          )}
        </p>
      </Fragment>
    );
  }

  renderModalUnit = (type, contentId) => {
    const { closeModalUnitModule, closeModalUnitPage } = this;
    const { showModalUnitPage } = this.state;
    const closeFunc =
      type === ITEM_TYPE.MODULE ? closeModalUnitModule : closeModalUnitPage;

    if (!showModalUnitPage) {
      return null;
    }

    return (
      <ContentDeleteModal
        numModules={type === ITEM_TYPE.MODULE ? 1 : 0}
        numPages={type !== ITEM_TYPE.MODULE ? 1 : 0}
        allModules={false}
        onCancel={closeFunc}
        onConfirm={() => this.deleteContent(type, contentId)}
      />
    );
  };

  deleteContent = async (type, contentId) => {
    const { isExtra } = this.props;
    const seasonId = MembershipService.hasSeason
      ? SeasonService.getSelectedSeasonInfo().id
      : null;

    try {
      if (type === ITEM_TYPE.MODULE) {
        await ContentService.deleteModule(contentId);
        this.closeModalUnitModule();
      } else {
        await ContentService.deletePage(contentId);
        this.closeModalUnitPage();
      }

      UiService.setAlertSuccess('content_removed_success');
    } catch (error) {
      UiService.handleError(error);
      DatahubEventsService.sendEvent({
        schema: new ClickDeleteContentSchema({
          success: false,
          errorCode: error?.data?.errorCode,
          componentName: ComponentNames.BUTTON_DELETE_PAGE
        })
      });
      return;
    }

    DatahubEventsService.sendEvent({
      schema: new ClickDeleteContentSchema({
        success: true,
        componentName: ComponentNames.BUTTON_DELETE_PAGE
      })
    });
    ContentService.fetchModulesList(seasonId, isExtra);
    OnboardingService.updateStatusContentAndApprovedStatus();
  };

  updateModulesOpen = (moduleId, openModule) => {
    const { openModulesList } = this.state;

    if (openModule && !openModulesList.includes(moduleId)) {
      this.setState({ openModulesList: [...openModulesList, moduleId] });
    } else if (!openModule) {
      const openModulesListUpdated = openModulesList.filter(
        (openModuleId) => openModuleId !== moduleId
      );

      this.setState({ openModulesList: openModulesListUpdated });
    }
  };

  renderRow = (index, snapshot) => {
    const {
      id,
      type,
      isExtra,
      onMouseDown,
      onMouseUp,
      isMobile,
      checkboxChange,
      checkAllpages,
      closedDroppable,
      openDuplicationModal,
      onReceiveDuplicationStatus,
      showModalMass,
      updateCheckedModule
    } = this.props;
    const {
      items,
      isModuleDragging,
      isPageDragging,
      classesList,
      isClassesLoaded,
      expandModules,
      checkedContent,
      objItemIdClasses,
      moduleName,
      openModulesList
    } = this.state;

    const isLast = items.length - 1 === index;

    const item = items[index];

    return (
      <Fragment key={item.id}>
        {type === ITEM_TYPE.MODULE ? (
          <ModuleType
            key={item.id}
            item={item}
            index={index}
            updateModuleName={this.updateModuleName.bind(this)}
            onBlurModuleNameHandler={this.onBlurModuleNameHandler.bind(this)}
            renderModuleFlags={this.renderModuleFlags.bind(this)}
            getClassTooltipContent={this.getClassTooltipContent.bind(this)}
            clearClassTooltipContent={this.clearClassTooltipContent.bind(this)}
            objItemIdClasses={objItemIdClasses}
            checkedContent={checkedContent}
            moduleName={moduleName}
            onMouseDown={onMouseDown}
            onMouseUp={onMouseUp}
            onDuplicate={openDuplicationModal}
            isMobile={isMobile}
            checkboxChange={checkboxChange}
            checkAllpages={checkAllpages}
            isDraggingOver={snapshot.isDraggingOver}
            isModuleDragging={isModuleDragging}
            isPageDragging={isPageDragging}
            classesList={classesList}
            isClassesLoaded={isClassesLoaded}
            expandModules={expandModules}
            isLast={isLast}
            items={items}
            urlWithParams={this.urlWithParams.bind(this)}
            closeModalUnitModule={this.closeModalUnitModule.bind(this)}
            closeModalUnitPage={this.closeModalUnitPage.bind(this)}
            isExtra={isExtra}
            updateModulesOpen={this.updateModulesOpen.bind(this)}
            openModulesList={openModulesList}
            showModalMass={showModalMass}
            updateCheckedModule={updateCheckedModule}
          />
        ) : (
          <PageType
            key={item.id}
            item={item}
            index={index}
            checkedContent={checkedContent}
            checkboxChange={checkboxChange}
            isMobile={isMobile}
            isExtra={isExtra}
            onMouseUp={onMouseUp}
            onMouseDown={onMouseUp}
            isModuleDragging={onMouseUp}
            isPageDragging={onMouseUp}
            closedDroppable={closedDroppable}
            isPageChecked={this.isPageChecked.bind(this)}
            onBlurPageNameHandler={this.onBlurPageNameHandler.bind(this)}
            pageHandleKeyPress={this.pageHandleKeyPress.bind(this)}
            actionsToggle={this.actionsToggle}
            urlWithParams={this.urlWithParams.bind(this)}
            showModalUnitPage={this.showModalUnitPage}
            pageId={this.state.showModalUnitPage}
            isLast={isLast}
            parentId={id}
            items={items}
            expandModules={expandModules}
            renderModalUnit={this.renderModalUnit}
            onReceiveDuplicationStatus={onReceiveDuplicationStatus}
          />
        )}
      </Fragment>
    );
  };

  renderList = (snapshot) => {
    const { items } = this.state;

    return items.map((_, index) => this.renderRow(index, snapshot));
  };

  render() {
    const { id, type, className, isExtra } = this.props;
    const { items } = this.state;
    const componentClass = classNames('droppable', className);

    return (
      <>
        <Droppable
          type={type}
          droppableId={id}
          key={id}
          isExtra={isExtra}
          mode="virtual"
          getContainerForClone={() => this.cloneRef.current}
          renderClone={(provided, _, rubric) => (
            <DraggingCard
              label={items[rubric.source.index].name}
              provided={provided}
              type={type}
            />
          )}
        >
          {(provided, snapshot) => {
            return (
              <div
                className={componentClass}
                ref={provided.innerRef}
                key={`${type}-${id}`}
              >
                {items && this.renderList(snapshot, provided)}
              </div>
            );
          }}
        </Droppable>

        <div ref={this.cloneRef} />
      </>
    );
  }
}
